export default __webpack_public_path__ + "static/media/product3.bea60a73.png";